import { useState } from "react"
import { toast } from 'react-hot-toast';
import Select from "react-select";
import ajaxParent from "../../../util/remote/ajaxParent";
import SystemModal from "../../Common/SystemModal";
import Loader from "../../Common/Loader";

const ConvertCreditToPM=(props)=>{

    const [loading, setLoading] = useState(false)
    const [student,setStudent] =useState("")
    const [amount,setAmount] =useState("")

    const data={
        credit_owner_user_id: props.userID,
        student_user_id: student,
        amount: amount
    }

    const handleAdd = async(e) =>{
        e.preventDefault()
        if (student > 0 && amount > 0) {
            setLoading(true)
            const server_response = await ajaxParent.convertCreditToPM(data);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                props.h();
                props.j(props.cpage);
            }
            else{
                toast.error(server_response.message); 
            }
        } else {
            toast.error("Please select the student and enter an amount!");
          } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleAdd}>Convert<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Convert Credit to Pocket Money"
            id="model-convert-credit-to-pm"
            size="md"
            footer={RenderFooter}
        >

        <div className="mb-4 col-12 form-group">
          <label htmlFor="">Select Student <span style={{color:"red"}}>*</span></label>
          <Select
            onChange={(e) => setStudent(e.student.user_id)}
            getOptionLabel={(option) => option.student.full_name}
            getOptionValue={(option) => option.student.user_id}
            isSearchable
            options={Array.isArray(props.studentList) ? props.studentList : []}
            value={
              Array.isArray(props.studentList) &&
              props.studentList.find((value) => value.student.user_id === student)
            }
          />
        </div>

        <div className="mb-4 col-12 form-group">
                <label htmlFor="">Amount <span style={{ color: "red" }}>*</span></label>
                <input type="text" value={amount} placeholder="Enter amount.." onChange={(e) => setAmount(e.target.value)} className="form-control" />
            </div>
       
        </SystemModal>
    )
}

export default ConvertCreditToPM
